/*
 * Jira Ticket:
 * Created Date: Thu, 9th Jul 2020, 16:22:59 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */
import React, { Fragment } from 'react';
import { CircularProgress, Link, Typography } from '@material-ui/core';

const RedirectModalContent = ({ approvalUrl, classes, translate }) => {
  return (
    <Fragment>
      <Typography color="primary" variant="h5">
        {translate('resources.SubscriptionTier.fields.redirectionModalTitle')}
      </Typography>
      <CircularProgress size={22} colour="primary" />
      <p>
        {translate(
          'resources.SubscriptionTier.fields.redirectionModalContent1'
        )}
      </p>
      <p>
        {translate(
          'resources.SubscriptionTier.fields.redirectionModalContent2'
        )}
      </p>
      {approvalUrl ? (
        <Link
          href={approvalUrl}
          color="secondary"
          className={classes.redirectionLink}
          target="_blank"
        >
          {translate(
            'resources.SubscriptionTier.fields.redirectionModalContentLinkText'
          )}
        </Link>
      ) : null}
    </Fragment>
  );
};

export default RedirectModalContent;
